// TanStack Query key factory for the AlertRule entity. Keeping the keys in
// one place lets mutations elsewhere in the app invalidate without reaching
// into hook internals.

export const alertRuleQueryKeys = {
  all: ["alert-rule"] as const,
  list: (communityId: string) =>
    [...alertRuleQueryKeys.all, "list", communityId] as const,
} as const;
